

import { useSelector, useDispatch} from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { deletePaketlemeItem } from "../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px;
            margin: 20px 0;
            width: 100%;
            gap: 40px;
            overflow: auto;
            
            &::-webkit-scrollbar {
                width: 0;
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }


            p{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
            }

            .btn-container{
                display: flex;
                gap: 40px;
            }
        }
    }
`

const DeleteLoadPaketlemeItemPermissionNestedModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {paketlemePermissionData} = useSelector(state => state.updateLoad)

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    // //! bu modal açıldığnda ekran ı lock lamak için
    // useEffect(() => {
    //     lockScroll()

    //     return () => {
    //         unlockScroll()
    //     }
    // }, [lockScroll, unlockScroll])


    // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    // useEffect(() => {
    //     if (location.pathname !== modalLocation) {
    //         dispatch(showModal(null))
    //     }
    // }, [dispatch, location.pathname, modalLocation])
    // dispatch(deleteRouteItem(item))
  return (
    <Container>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <p>Paketleme Tipini Silmek İstediğinize Emin Misiniz?</p>
            <div className="btn-container">
                <Btn bgColor="#E85446" width={"120px"} handleClick={() => {dispatch(deletePaketlemeItem(paketlemePermissionData)); dispatch(showNestedModal(null))}}>Sil</Btn>
                <Btn bgColor="#E85446" width={"120px"} handleClick={() => dispatch(showNestedModal(null))}>Geri Dön</Btn>
            </div>
            </div>
        </div>
    </Container>
  )
}

export default DeleteLoadPaketlemeItemPermissionNestedModal